import { FeedbackDailyStat } from './feedbackApi';
 
export interface FeedbackTrendDataset {
  labels: string[];
  likes: number[];
  dislikes: number[];
}
 
export const buildFeedbackTrendDataset = (
  dailyStats: FeedbackDailyStat[]
): FeedbackTrendDataset => {
  const labels    = dailyStats.map((s) => s.date);
  const likes     = dailyStats.map((s) => s.likes);
  const dislikes  = dailyStats.map((s) => s.dislikes);
  return { labels, likes, dislikes };
};
 